class AppState
{
    constructor()
    {
        this.state = {};
        this.subscriptions = [];
    }

    set(key, value)
    {
        this.state[key] = value;
        this.subscriptions.forEach(callback => callback(key, value));
        console.log('AppState', this.state);
    }

    get(key, fallback)
    {
        return this.state[key] || fallback;
    }

    subscribe(callback)
    {
        this.subscriptions.push(callback);
    }

    unsubscribe(callback)
    {
        let i = 0;
        while (i < this.subscriptions.length)
        {
            if (this.subscriptions[i] == callback)
            {
                this.subscriptions.splice(i, 1);
            }
            else
            {
                i++;
            }
        }
    }
}

const gs = new AppState();
export { gs as AppState };